export const GRID_SWITCH_ACTIVE_TEXT = '开'
export const GRID_SWITCH_INACTIVE_TEXT = '关'

export function resolveSwitchBoolean(value: unknown): boolean {
  return value === true || value === 'true' || value === 1 || value === '1'
}

export function formatSwitchDisplayText(value: unknown): string {
  return resolveSwitchBoolean(value)
    ? GRID_SWITCH_ACTIVE_TEXT
    : GRID_SWITCH_INACTIVE_TEXT
}
